import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import {
  VERIFY_AUTH,
  GET_USER_ATTRIBUTES,
  SET_GRAPHQL_API_HEADER
} from "./store/auth.module";
import { Amplify, graphqlOperation } from "aws-amplify";
import * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";
import "@aws-amplify/ui-vue";
import PubSub from "@aws-amplify/pubsub";
import API from "@aws-amplify/api";
import Vuelidate from "vuelidate";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import * as PermissionsService from "@/services/PermissionsService.js";
import * as LoggerService from "@/services/LoggerService.js";
import * as mutations from "@/graphql/mutations";
import * as queries from "@/graphql/queries";
import * as subscriptions from "@/graphql/subscriptions";
import AmplifyConfigService from "@/services/AmplifyConfigService.js";
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

AmplifyConfigService.configureAmplify(API);

AmplifyConfigService.configureAmplify(PubSub);

AmplifyConfigService.configureAmplify(Amplify);

store.dispatch(SET_GRAPHQL_API_HEADER);

Vue.use(Vuelidate);
Vue.use(API);
Vue.use(AmplifyPlugin, AmplifyModules);

window.$ = window.jQuery = require("jquery");

Vue.config.productionTip = false;

// Global 3rd party plugins
import "bootstrap";
import "popper.js";
import "tooltip.js";
import "perfect-scrollbar";

// Vue 3rd party plugins
import i18n from "./common/plugins/vue-i18n";
import vuetify from "./common/plugins/vuetify";
import "./common/plugins/bootstrap-vue";
import "./common/plugins/perfect-scrollbar";
import "./common/plugins/highlight-js";
import "@babel/polyfill";
import "@mdi/font/css/materialdesignicons.css";

// Ensure we checked auth before each page load.
router.beforeEach((to, from, next) => {
  Promise.all([store.dispatch(VERIFY_AUTH)]).then(next);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

Object.defineProperty(Vue.prototype, "$role", {
  value: PermissionsService
});

Object.defineProperty(Vue.prototype, "$logger", {
  value: LoggerService
});

Vue.mixin({
  methods: {
    async getMerchantId() {
      var result = null;
      await store.dispatch(GET_USER_ATTRIBUTES).then(attributes => {
        result = attributes["family_name"];
      });
      if (!result) throw new Error("No merchantId exists for this user.");
      return result;
    },
    async gqlQuery(name, payload) {
      return await API.graphql(graphqlOperation(queries[name], payload));
    },
    async mutation(name, payload) {
      return await API.graphql(graphqlOperation(mutations[name], payload));
    },
    async subscription(name, payload) {
      return await API.graphql(graphqlOperation(subscriptions[name], payload));
    }
  }
});

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App),
  validations: {}
}).$mount("#app");
